const SCRIPT_SRC = 'https://cdn.payphonetodoesposible.com/box/v2.0/payphone-payment-box.js';
const CSS_HREF = 'https://cdn.payphonetodoesposible.com/box/v2.0/payphone-payment-box.css';

// Map a nivel de módulo, COMPARTIDO por cualquier widget de Payphone de la
// app (Compra Asistida, Puerta a Puerta, los que vengan) — poblado de forma
// SÍNCRONA (no en el callback onload). El script de la Cajita declara
// variables globales sin IIFE, así que cargarlo dos veces (dos widgets
// montados a la vez, o el doble-montaje de React StrictMode en dev) revienta
// con "Identifier '_m' has already been declared". Si cada componente tuviera
// su propio Map no se coordinarían entre sí — por eso vive en un módulo aparte.
const cargaScript = new Map();

export function cargarPayphoneScript() {
  if (cargaScript.has(SCRIPT_SRC)) return cargaScript.get(SCRIPT_SRC);
  const promesa = new Promise((resolve, reject) => {
    if (!document.querySelector(`link[href="${CSS_HREF}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = CSS_HREF;
      document.head.appendChild(link);
    }
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('No se pudo cargar Payphone.'));
    document.body.appendChild(script);
  });
  cargaScript.set(SCRIPT_SRC, promesa);
  return promesa;
}
